var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 12.8573H14.7619V11.4288M13.3334 7.14304H14.7619V8.57161M6.66671 7.14304H5.23814V8.57161M5.23814 11.4288V12.8573H6.66671M10 11.9049C8.94807 11.9049 8.09528 11.0522 8.09528 10.0002C8.09528 8.94822 8.94807 8.09542 10 8.09542C11.052 8.09542 11.9048 8.94822 11.9048 10.0002C11.9048 11.0522 11.052 11.9049 10 11.9049ZM4.28575 5.23828H15.7143C16.2403 5.23828 16.6667 5.66468 16.6667 6.19066V13.8097C16.6667 14.3357 16.2403 14.7621 15.7143 14.7621H4.28576C3.75977 14.7621 3.33337 14.3357 3.33337 13.8097V6.19066C3.33337 5.66468 3.75977 5.23828 4.28575 5.23828Z",
    stroke: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.3ed8c07be61e71adb0b966fa89f9599f.svg";
export { ForwardRef as ReactComponent };